"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alignment = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../icon/Icon"));
var Badge_1 = __importStar(require("../badge/Badge"));
var DropDownContent_1 = __importDefault(require("./DropDownContent"));
var DropdownPositionUtils_1 = __importDefault(require("../../utils/DropdownPositionUtils"));
var KeyboardEventKeys_1 = __importDefault(require("../../common/enums/KeyboardEventKeys"));
var ClassNames;
(function (ClassNames) {
    ClassNames["OPEN"] = "fds-dropdown-open";
    ClassNames["FULLSCREEN_VIEW"] = "fds-fullscreen-view";
    ClassNames["FULLSCREEN_OPEN"] = "fds-dropdown-fullscreen-open";
    ClassNames["FULLSCREEN"] = "fds-dropdown-fullscreen";
    ClassNames["TEXT_TRIGGER"] = "fds-dropdown-text-trigger";
    ClassNames["RIGHT_ALIGNMENT"] = "fds-dropdown-right-aligned";
    ClassNames["FILTER_COUNTER_TEXT"] = "fds-dropdown-items-selected";
    ClassNames["COLLAPSE_PADDING"] = "collapse-padding";
    ClassNames["HAS_ACTION"] = "has-action";
})(ClassNames || (ClassNames = {}));
var Alignment;
(function (Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
})(Alignment = exports.Alignment || (exports.Alignment = {}));
// Classes toggled on the <body> tag when component is open
var DocumentVisibilityClasses = [
    ClassNames.FULLSCREEN_OPEN,
    ClassNames.FULLSCREEN_VIEW
];
var DropDown = /** @class */ (function (_super) {
    __extends(DropDown, _super);
    function DropDown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrapper = react_1.default.createRef();
        _this.content = react_1.default.createRef();
        _this.contentWrapper = react_1.default.createRef();
        _this.trigger = react_1.default.createRef();
        _this.state = {
            open: _this.props.open,
            documentVisibilityClasses: DocumentVisibilityClasses
        };
        _this.setDropdownPosition = function () {
            _this.toggleOpenClassOnDocument();
            if (_this.state.open) {
                _this.position();
            }
            else {
                _this.cleanPosition();
            }
        };
        _this.globalClickHandler = function (e) {
            if (_this.wrapper.current && _this.wrapper.current.contains(e.target)) {
                return;
            }
            _this.state.open && _this.dismiss();
        };
        _this.globalKeyHandler = function (e) {
            (_this.state.open && e.key === KeyboardEventKeys_1.default.ESCAPE) && _this.dismiss();
        };
        _this.dismiss = function () {
            _this.setState(function () { return ({
                open: false
            }); }, function () {
                _this.props.onRequestClose && _this.props.onRequestClose();
            });
        };
        //FIXME: THIS SHOULD BE PRIVATE; UPDATE TEST TO CLICK RATHER THAN CALL THIS METHOD DIRECTLY - SJO
        _this.toggle = function (e) {
            _this.setState(function (prevState) { return ({
                open: !prevState.open
            }); }, function () {
                _this.props.onRequestToggle && _this.props.onRequestToggle(e, { open: _this.state.open });
            });
        };
        /** Global event handlers to be added at mount and removed on unmount */
        _this.globalEventRegistry = [
            { event: 'click', fn: _this.globalClickHandler, useCapture: true },
            { event: 'keydown', fn: _this.globalKeyHandler, useCapture: false }
        ];
        return _this;
    }
    DropDown.prototype.componentDidMount = function () {
        this.globalEventRegistry.forEach(function (registeredEvt) {
            document.addEventListener(registeredEvt.event, registeredEvt.fn, registeredEvt.useCapture);
        });
    };
    DropDown.prototype.componentWillUnmount = function () {
        this.globalEventRegistry.forEach(function (registeredEvt) {
            document.removeEventListener(registeredEvt.event, registeredEvt.fn, registeredEvt.useCapture);
        });
    };
    DropDown.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.open !== this.props.open) {
            this.setState({
                open: !prevProps.open
            });
        }
        // Always fire positioning logic because there is conditional open/close clean-up happening there
        // and we might need to re-position if the children inside of a dropdown change, for example
        this.setDropdownPosition();
    };
    DropDown.prototype.toggleOpenClassOnDocument = function () {
        this.state.open && this.props.fullscreenOptions.enabled ?
            this.addVisibilityClasses() :
            this.removeVisibilityClasses();
    };
    DropDown.prototype.addVisibilityClasses = function () {
        this.state.documentVisibilityClasses.forEach(function (className) {
            document.documentElement.classList.add(className);
        });
    };
    DropDown.prototype.removeVisibilityClasses = function () {
        this.state.documentVisibilityClasses.forEach(function (className) {
            document.documentElement.classList.remove(className);
        });
    };
    DropDown.prototype.togglePosition = function () {
        this.state.open && this.setDropdownPosition();
    };
    DropDown.prototype.position = function () {
        var dropdownPositionUtils = new DropdownPositionUtils_1.default(this.wrapper.current, this.trigger.current, this.content.current, this.contentWrapper.current);
        dropdownPositionUtils.autoPosition();
    };
    DropDown.prototype.cleanPosition = function () {
        var dropdownPositionUtils = new DropdownPositionUtils_1.default(this.wrapper.current, this.trigger.current, this.content.current, this.contentWrapper.current);
        dropdownPositionUtils.teardown();
    };
    DropDown.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, buttonValue = _b.buttonValue, classes = _b.classes, compactButton = _b.compactButton, hasForm = _b.hasForm, iconName = _b.iconName, fullscreenOptions = _b.fullscreenOptions, badgeText = _b.badgeText, updateText = _b.updateText, cancelText = _b.cancelText, cancelDisabled = _b.cancelDisabled, onCancel = _b.onCancel, onUpdate = _b.onUpdate, updateDisabled = _b.updateDisabled, disabled = _b.disabled, textTrigger = _b.textTrigger, alignment = _b.alignment, collapsePadding = _b.collapsePadding, filtersSelected = _b.filtersSelected;
        var open = this.state.open;
        var filterCounterText = filtersSelected > 0 ? filtersSelected.toString() : badgeText;
        var dropDownClasses = classnames_1.default('fds-dropdown', (_a = {},
            _a[ClassNames.OPEN] = open,
            _a[ClassNames.FULLSCREEN] = fullscreenOptions.enabled,
            _a[ClassNames.FILTER_COUNTER_TEXT] = filterCounterText,
            _a[ClassNames.TEXT_TRIGGER] = textTrigger,
            _a[ClassNames.RIGHT_ALIGNMENT] = alignment === Alignment.RIGHT,
            _a[ClassNames.COLLAPSE_PADDING] = collapsePadding,
            _a[ClassNames.HAS_ACTION] = updateText || cancelText,
            _a), classes);
        var dropDownButtonClasses = classnames_1.default('fds-dropdown-trigger fds-dropdown-button fds-button fds-button-small', {
            'fds-button-utility': !textTrigger,
            'is-disabled': disabled,
            'is-selected': open,
            'fds-dropdown-button-compact': compactButton
        });
        var getButtonIconAndFilterCount = function () {
            if (typeof filtersSelected === 'number' && textTrigger) {
                return filtersSelected > 0 ? react_1.default.createElement("span", { className: "fds-text-trigger-count" },
                    "(",
                    filterCounterText,
                    ")") : react_1.default.createElement(Icon_1.default, { name: 'filter-list', classes: "fds-dropdown-button-icon" });
            }
            else {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    (iconName && !filterCounterText) && (react_1.default.createElement(Icon_1.default, { name: iconName, classes: "fds-dropdown-button-icon" })),
                    filterCounterText && !textTrigger && (react_1.default.createElement(Badge_1.default, { classes: classnames_1.default({ 'fds-badge-text': filterCounterText }), text: filterCounterText, type: Badge_1.BadgeType.SMALL, theme: Badge_1.NumberedBadgeTheme.NUMBERED_PRIMARY }))));
            }
        };
        var triggerButtonElement;
        if (this.props.triggerButton) {
            triggerButtonElement = react_1.default.cloneElement(this.props.triggerButton, { onClick: this.toggle,
                parentRef: this.trigger,
                disabled: disabled,
                classes: classnames_1.default('fds-dropdown-trigger fds-dropdown-button', {
                    'is-disabled': disabled,
                    'is-selected': open
                })
            });
        }
        else {
            triggerButtonElement = (react_1.default.createElement("button", { ref: this.trigger, disabled: disabled, type: "button", "aria-labelledby": "dropdown-button-label", "aria-expanded": this.state.open, className: dropDownButtonClasses, onClick: this.toggle },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: "fds-button-label fds-dropdown-button-label" }, buttonValue),
                    getButtonIconAndFilterCount())));
        }
        return (react_1.default.createElement("div", { ref: this.wrapper, className: dropDownClasses },
            triggerButtonElement,
            react_1.default.createElement(DropDownContent_1.default, { cancelText: cancelText, cancelDisabled: cancelDisabled, fullscreenOptions: fullscreenOptions, onCancel: onCancel, onUpdate: onUpdate, updateDisabled: updateDisabled, updateText: updateText, hasForm: hasForm, refContent: this.content, refContentWrapper: this.contentWrapper }, children)));
    };
    DropDown.defaultProps = {
        children: [],
        fullscreenOptions: {
            enabled: false
        },
        alignment: Alignment.LEFT
    };
    return DropDown;
}(react_1.default.Component));
exports.default = DropDown;
